module.exports = __webpack_public_path__ + "img/tongren-3e3dae.png";